import { render, staticRenderFns } from "./workday.vue?vue&type=template&id=a65b4174&scoped=true"
import script from "./workday.vue?vue&type=script&lang=js"
export * from "./workday.vue?vue&type=script&lang=js"
import style0 from "./workday.vue?vue&type=style&index=0&id=a65b4174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65b4174",
  null
  
)

export default component.exports